<template>
  <div>
    <div>
      <div
        class="message-marked"
        v-html="parsedContent"
      />
      <div v-if="image" class="rich-image-previewer" @click="closeImage">
        <img
        class="rich-image-preview"
        :style="{
          transform: `scale(1) rotate(0deg)`,
        }"
        :src="imageSrc"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import vue  from '../../../../../../adapter-vue';
import { parseMarkdown } from "./marked";
import { customerServicePayloadType } from '../../../../../../interface';
const { computed,ref } = vue;
interface Props {
  payload: customerServicePayloadType;
}
export default {
  components: {},
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  setup(props: Props, { emit }) {
    const image = ref(false);
    const imageSrc = ref('');
    const imageList = [];
    const parsedContent = computed(() => {
      // @ts-ignore
      window.onMarkdownImageClicked = function(href: string) {
        image.value = !image.value;
        imageSrc.value = decodeURIComponent(href);
      }
      // @ts-ignore
      window.onMarkdownMediaLoad = function() {
        emit('heightChanged');
      }
      return parseMarkdown(props.payload.content);
    });

    const closeImage = () => {
      image.value = !image.value;
      imageSrc.value = '';
    }

    return {
      props,
      parsedContent,
      image,
      imageSrc,
      closeImage,
      imageList,
    };
  },
};
</script>
<style lang="scss">
.rich-image-previewer {
  position: fixed;
  z-index: 101;
  width: 100vw;
  height: 100vh;
  background: rgba(#000, 0.8);
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.rich-image-preview {
  max-width: 90%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  pointer-events: auto;
}
.message-video {
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;

  &-box {
    max-width: min(calc(100vw - 180px), 300px);
    font-size: 0;

    video {
      max-width: min(calc(100vw - 180px), 300px);
      max-height: min(calc(100vw - 180px), 300px);
      width: inherit;
      height: inherit;
    }
  }
}
.dialog-video {
  position: fixed;
  z-index: 12;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-close {
    display: flex;
    justify-content: flex-end;
    background: #000;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
  }

  &-box {
    display: flex;
    flex: 1;
    max-height: 100%;
    padding: 6rem;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;

    video {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
